<template>
    <ModalComponent
        :name="'borrar-' + categoria.id"
        :title="'¿Seguro que quieres borrar el categoría: ' + categoria.name + '?'"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <h2>Datos del categoria</h2>
            </div>
            <div class="col-12">
                <ul class="list-group list-group-unbordered mb-3">
                    <li class="list-group-item">
                        <b>Nombre:</b> {{ categoria.name }}
                    </li>
                    <li class="list-group-item">
                        <b>Categoría:</b> {{ categoria.precio }}
                    </li>
                </ul>
            </div>
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿BORRAR CATEGORÍA?</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="borrarCategoria">SI, BORRAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['categoria'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.categoria.id, borrado);
            },
            borrarCategoria() {
                this.loading = true;

                var params = {
                    lista_id: this.lista_id,
                    categoria_id: this.categoria.id,
                    filters : {}
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.borrar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message, {
                        message: 'Categoría eliminada correctamente'
                    });
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error, {
                        message: 'No puedes borrar una categoría asociada a un deportista.'
                    });
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
